import i18next from "i18next";
import { InvestmentTypeEnum } from "@bn/api/apiv1";
import {
  CsvCashTransactionRow,
  CsvImportPerformAttributesTypeEnum,
  CsvRow,
} from "@bn/api/apiv3";
import { getCurrencySymbol } from "@helpers";
import { shouldIgnoreFieldError } from "./shouldIgnoreFieldError";

// A row has a "blocking" error when it has a problem that would actually
// prevent the CSV import from proceeding (i.e. it would keep the Next
// button disabled). Informational field errors that do not block the
// submission (e.g. missing booking info on a cash transaction) are not
// considered blocking here.
export const isRowBlocked = (
  row: CsvRow,
  type: CsvImportPerformAttributesTypeEnum
): boolean => {
  if (type === "booking") {
    return Object.values(row).some(
      (field) =>
        field != null && !shouldIgnoreFieldError(field.name) && field.error
    );
  }

  const cashRow = row as CsvCashTransactionRow;
  return (
    !cashRow.amount?.value ||
    !cashRow.counterpart_name?.value ||
    !cashRow.bank_booking_date?.value
  );
};

const nolLabel = (currency: string = "EUR", type?: InvestmentTypeEnum) => {
  const currencySymbol = getCurrencySymbol(currency);

  if (type === "31_bond") return currencySymbol;
  if (type === "61_pmetals")
    return i18next.t("transactionWizard.priceAndDateStep.gram");
  return i18next.t("transactionWizard.priceAndDateStep.lots");
};

const priceLabel = (currency: string = "EUR", type?: InvestmentTypeEnum) => {
  const currencySymbol = getCurrencySymbol(currency);

  if (type === "31_bond") return "%";
  return currencySymbol;
};

export const getInputAdornment = (
  name: string,
  currency: string,
  taxAndCommissionInEur: boolean,
  type?: InvestmentTypeEnum
) => {
  switch (name) {
    case "security_price":
      return priceLabel(currency, type);
    case "tax_amount":
    case "commission":
      return getCurrencySymbol(taxAndCommissionInEur ? "EUR" : currency);
    case "number_of_lots":
      return nolLabel(currency, type);
    default:
      return "";
  }
};
